// src/com/trans_plan_launch/TransPlanLaunch.js
import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Box } from '@mui/system';
import { IconButton, CircularProgress, Button, Box } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle'; // 배차+
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'; // 배차-
import BackupIcon from '@mui/icons-material/Backup'; // 운송요청 업로드
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import LightbulbCircleIcon from '@mui/icons-material/LightbulbCircle'; // 동적신규.
import { useLazyQuery, useMutation, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import {
    ContentConainer, ContentHeader, ContentBody, ControlBox, ToolBox
} from '../../common/TopViewControl';
import { ApiMsg, AppObject, AppStyle, AppWord, CodeGroup } from '../../value/AppConst';
import {
    arriveInfoListRepo,
    codeTreeRepo,comInfoListRepo,
    transPlanChangedRepo,transPlanLaunchListParamRepo,
    transPlanLaunchListRepo, userInfoRepo, vehInfoListOfDcRepo,
    vehTypeGroupOrderListByDcRepo, waveListRepo
} from '../../value/AppModel';
import { LIST_TRANS_PLAN_TSR } from '../trans_plan_tsr/TransPlanTsrGql';
import { useAlertSetter } from '../../api/app-hook';
import { LIST_ARRIVE_INFO } from '../arrive_info/ArriveInfoGql';
import ValueMisc from '../../value/ValueMisc';
import AutoTextField from '../../common/AutoTextField';
import VzmDateField from '../../common/VzmDateField';
import IsValid from '../../value/IsValid';
import TransPlanLaunchItem from './TransPlanLaunchItem';
import {
    LIST_VEH_TYPE_GROUP_ORDER_BY_DC
} from '../veh_type_group_order/VehTypeGroupOrderGql';
import { LIST_COM_INFO } from '../com_info/ComInfoGql';
import { devideVehiclesByCompany, LIST_VEH_INFO_OF_DC } from '../veh_info/VehInfoGql';
import { TransPlanLaunchDictionary } from './TransPlanLaunchDict';
import {
    ADD_TRANS_PLAN, EDIT_TRANS_PLAN,
    OFF_TRANS_PLAN_TRUCK, REMOVE_TRANS_PLAN, SET_TRANS_PLAN_TRUCK
} from '../trans_plan/TransPlanGql';
import TransPlanBindManager from '../trans_plan_bind/TransPlanBindManager';
import TransPlanUploader from './TransPlanUploader';
import StoreHouseSvg from '../../asset/image/store_house.svg';

const DefaultBoxCount = 5; // number of (plan and empty) TransPlanLaunchItem

const vehSorter = (a, b) => {
    const aNew = a.vehPlates.indexOf('신규') > -1;
    const bNew = b.vehPlates.indexOf('신규') > -1;
    if(aNew && !bNew) return 1;
    if(!aNew && bNew) return -1;
    return a.vehPlates.localeCompare(b.vehPlates);
};

/**
 * 수동 배차등록 목록 (날짜, 도착지에 대하여 hocha들 나열(목록))
 * 1. 목록 조회해서 hocha순으로 표시.
 * 2. 각 호차별로 기본 정보 전달(baseData)
 * 3. 데이터 없는 경우도 있음(빈 상자) null item
 * 4. 배차 삭제 - 과거 PR_TRANS_PLAN_DEL
 * @param {*} param0 
 */
export default function TransPlanLaunch({
    viewServiceTags, // for switching view
    show = true,
}) {
    const codeTree = useReactiveVar(codeTreeRepo);
    const sessionInfo = useReactiveVar(userInfoRepo);
    const storeList = useReactiveVar(arriveInfoListRepo);
    const transPlanLaunchListParam = useReactiveVar(transPlanLaunchListParamRepo);
    //const transPlanLaunchListData = useReactiveVar(transPlanLaunchListRepo);
    const transPlanChanged = useReactiveVar(transPlanChangedRepo);
    const [launchBoxList, setLaunchBoxList] = useState([]); // [ {item, hocha} ]
    const vehInfoListOfDcData = useReactiveVar(vehInfoListOfDcRepo);
    const vehTypeGroupOrderListByDc = useReactiveVar(vehTypeGroupOrderListByDcRepo);
    const vehTypeList = useMemo(()=>{
        if(vehTypeGroupOrderListByDc.records.length > 0) {
            const list = [...vehTypeGroupOrderListByDc.records];
            list.unshift({vehTypeId:AppWord.ChooseValue, vehTypeName:AppWord.ChooseKorean});
            return list;
        }
        return [{vehTypeId:AppWord.ChooseValue, vehTypeName:AppWord.ChooseKorean}];
    }, [vehTypeGroupOrderListByDc]);
    const comInfoListData = useReactiveVar(comInfoListRepo);
    const comInfoList = useMemo(()=>{
        if(comInfoListData.records.length > 0) {
            const list = comInfoListData.records.filter(com=>com.dcCd===sessionInfo.user.dscIdAs && com.useYn==='Y') //[...comInfoListData.records];
            list.unshift({comId:AppWord.ChooseValue, comName:AppWord.ChooseKorean});
            return list;
        }
        return [{comId:AppWord.ChooseValue, comName:AppWord.ChooseKorean}];
    }, [comInfoListData]);
    const [docknoMemo, setDocknoMemo] = useState(null);
    const [bindManagerState, setBindManagerState] = useState({open: false, plan: null});
    const [openUploader, setOpenUploader] = useState(false);
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const slotCountWantedRef = useRef(DefaultBoxCount); // 원하는 호차 상자 수. 최소값=DafaultBoxCount
    const loadRef = useRef(false);
    const lastReloadRef = useRef(0);
    const planDateRef = useRef(null);
    const transPlanLaunchListParamRef = useRef(transPlanLaunchListParam);
    const skipInitTransPlanChangedRef = useRef(true); // transPlanChanged 이벤트 초기회피
    useEffect(() => {
        transPlanLaunchListParamRef.current = transPlanLaunchListParam;
    }, [transPlanLaunchListParam]);
    
    // ##### Call GraphQL to get List #####
    const [getTransPlanTsrList, responseList] = useLazyQuery(LIST_TRANS_PLAN_TSR, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
        onError: (error) => addAlert({title: TransPlanLaunchDictionary.errorTitle.Get, message: [error.message]})
    });
    // Get store list from arrive_info table.
    const [getArriveInfoList, responseStoreList] = useLazyQuery(LIST_ARRIVE_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetStoreList(data, option)},
        onError: (error) => addAlert({title: '도착지 목록 조회 오류', message: [error.message]})
    });
    const [getVehTypeGroupOrderList, responseVehTypeList] = useLazyQuery(LIST_VEH_TYPE_GROUP_ORDER_BY_DC, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetVehTypeList(data, option)},
        onError: (error) => addAlert({title: "차종목록 조회 오류", message: [error.message]})
    });
    const [getComInfoList, responseComList] = useLazyQuery(LIST_COM_INFO, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetComList(data, option)},
        onError: (error) => addAlert({title: '운송사 목록 조회 오류', message: [error.message]})
    });
    const [getVehInfoListOfDc, responseVehInfoList] = useLazyQuery(LIST_VEH_INFO_OF_DC, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetVehInfoList(data, option)},
        onError: (error) => addAlert({title: "차량목록 조회 오류", message: [error.message]})
    });

    // ##### GraphQL Mutation. 'onError' for prevent from printing error at console (Uncaught exception) ###
    const [addTransPlan, responseAdd] = useMutation( ADD_TRANS_PLAN, {
		onCompleted: (data, option) => onCompleteAdd(data, option), 
		onError: (error) => addAlert({title: TransPlanLaunchDictionary.errorTitle.Add, message: [error.message]})
	} );
    const [editTransPlan, responseEdit] = useMutation( EDIT_TRANS_PLAN, {
		onCompleted: (data, option) => onCompleteEdit(data, option),
		onError: (error) => addAlert({title: TransPlanLaunchDictionary.errorTitle.Edit, message: [error.message]})
	} );
    const [removeTransPlan, responseRemove] = useMutation( REMOVE_TRANS_PLAN, {
		onCompleted: (data, option) => onCompleteRemove(data, option),
		onError: (error) => addAlert({title: TransPlanLaunchDictionary.errorTitle.Remove, message: [error.message]})
	});
    const [setTransPlanTruck, responseSetTruck] = useMutation( SET_TRANS_PLAN_TRUCK, {
        onCompleted: (data, option) => onCompleteSetTruck(data, option),
        onError: (error) => addAlert({title: "차량배정 오류", message: [error.message]})
    });
    const [offTransPlanTruck, responseOffTruck] = useMutation( OFF_TRANS_PLAN_TRUCK, {
        onCompleted: (data, option) => onCompleteOffTruck(data, option),
        onError: (error) => addAlert({title: "차량배정 초기화 오류", message: [error.message]})
    });
    // 추가예정: 차량설정, 차량제거(초기화), 동적, 메시지, 운송요청 업로드
    
    const getTransPlanTsrListNow = (storeId, planDate) => {
        const dcCd = sessionInfo.user.dscIdAs;
        if(!planDate) {
            planDate = ValueMisc.getYMD();
        }
        const param = {variables:{dcCd:dcCd, storeId:storeId, planDate:planDate}};
        getTransPlanTsrList(param);
        lastReloadRef.current = new Date().getTime()/1000;
    };

    const getTransPlanTsrListUsingParam = () => {
        if(transPlanLaunchListParam.storeId && transPlanLaunchListParam.planDate) {
            getTransPlanTsrListNow(transPlanLaunchListParam.storeId, transPlanLaunchListParam.planDate);
        }
    };

    
    // 날짜, 점포 변경 시 TSR 조회 호출
    // 다른 화면에서 transPlanTsrListParam 설정하고 이 화면으로 들어오면 바로 조회 가능함.
    useEffect(() => {
        if(transPlanLaunchListParam.storeId && transPlanLaunchListParam.planDate) {
            //getTransPlanTsrListNow(transPlanLaunchListParam.storeId, transPlanLaunchListParam.planDate);
            getTransPlanTsrListUsingParam();
        }
        else if(!transPlanLaunchListParam.planDate) {
            const newParam = {...transPlanLaunchListParam, planDate:ValueMisc.getYMD()};
            transPlanLaunchListParamRepo(newParam);
        }
    }, [transPlanLaunchListParam]);
    
    // 먼저 Store 목록을 가져온 후 transPlanTsrListParam의 내용에 따라서 최초 LIST_TRANS_PLAN_TSR 호출
    useEffect(() => {
        if(!loadRef.current) {
            loadRef.current = true;
            let diff = new Date().getTime()/1000 - storeList.when;
            if(diff > 300) {
                getArriveInfoList({variables:{dcCd:sessionInfo.user.dscIdAs}});
            }

            diff = new Date().getTime()/1000 - vehTypeGroupOrderListByDc.when;
            if(diff > 300) {
                getVehTypeGroupOrderList({variables:{dcCd:sessionInfo.getDcCd()}});
            }

            diff = new Date().getTime()/1000 - comInfoListData.when;
            if(diff > 300) {
                getComInfoList();
            }

            diff = new Date().getTime()/1000 - vehInfoListOfDcData.when;
            if(diff > 300) {
                getVehInfoListOfDc({variables:{dcCd:sessionInfo.user.dscIdAs}});
            }
            // const planGroup = ValueMisc.getCodes(codeTree, CodeGroup.AUTO_PLAN_ORDER_GROUP);
            const waveCodes = ValueMisc.getCodes(codeTree, CodeGroup.TRANS_TYPE_CD);
            const list = [{transTypeCd: AppWord.ChooseValue, label: AppWord.ChooseKorean}];
            waveCodes.forEach(item => {
                list.push({transTypeCd: item.codeId, label: item.codeName});
            });
            waveListRepo(list);
        }
    }, []);
    
    // trans_plan 테이블에 추가 또는 삭제가 있을 경우 다시 읽는다.
    useEffect(() => {
        /*
        다시 읽기를 실행하는 대부분의 경우, 직접 getTransPlanTsrListNow를 호출하는 대신
        transPlanChangedRepo를 호출하여 transPlanChanged 이벤트를 발생시키고,
        이 이벤트를 감지하여 getTransPlanTsrListNow를 호출하도록 한다.
        왜냐하면, 그로 인해 가져오는 데이터는 이 컴포넌트 내부뿐만 아니라, 다른 화면에서도
        변경될 수 있고, 그 결과 transPlanChangedRepo 변화를 통해 이 화면에서도
        데이터를 반영해 줘야 한다. 즉, 하나의 데이터가 여러곳에서 변경되는데, 그 변경을
        감지해 반영하는 방법을 통일시키기 위해서이다.
        단, 하나의 예외는 UI에서 storeId와 planDate를 변경하는 경우인데, 이 것은
        데이터를 변경한 것이 아니라 단순히 조회조건을 변경한 것이기 때문이다.
        */
        if(skipInitTransPlanChangedRef.current) {
            skipInitTransPlanChangedRef.current = false;
            return;
        }
        const { storeId, planDate } = transPlanLaunchListParamRef.current;
        if(storeId && planDate) {
            getTransPlanTsrListNow(storeId, planDate);
        }
    }, [transPlanChanged]);

    // wave code 목록 채우기.
    const baseData = useMemo(() => {
        if(storeList.records.length > 0 && transPlanLaunchListParam.storeId && transPlanLaunchListParam.planDate) {
            const store = storeList.records.find(item => item.storeId === transPlanLaunchListParam.storeId);
            if(store) {
                const arr = {...store};
                if(arr.basicExpectRunTime) {
                    if(arr.basicExpectRunTime.length < 4) {
                        // "20", "140" 이런 것들이 꽤 있음. 젠장.
                        // 4자리 미만이면 0을 채워서 4자리로 맞춤.
                        arr.basicExpectRunTime = arr.basicExpectRunTime.padStart(4, '0');
                    }
                }
                return {
                    dcCd: store.dcCd,
                    storeId: store.storeId,
                    arriveId: store.arriveId,
                    basicDockno: store.basicDockno,
                    planDate: transPlanLaunchListParam.planDate,
                    arriveInfo: arr,
                };
            }
        }
        return {};
    }, [transPlanLaunchListParam, storeList]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        // lastReloadRef.current = new Date().getTime()/1000;
        if(data.transPlanTsrList) {
            // got order by hocha already
            transPlanLaunchListRepo({when:new Date().getTime()/1000, records:data.transPlanTsrList});
            // get max hocha (1 to maxHocha)
            let lastDockno = baseData.basicDockno;
            let maxHocha = data.transPlanTsrList.reduce((acc, item) => {
                lastDockno = item.dockno;
                return item.hocha > acc ? item.hocha : acc;
            }, 0);
            // 그냥 조심.
            if(slotCountWantedRef.current < DefaultBoxCount) slotCountWantedRef.current = DefaultBoxCount;

            if(maxHocha < slotCountWantedRef.current) maxHocha = slotCountWantedRef.current; // 늘리기.
            else if(maxHocha > slotCountWantedRef.current) {
                // 원하는 것보다 더 많은 운송요청이 있음. 원하는 값을 오히려 늘려 줘야 함. Sync.
                slotCountWantedRef.current = maxHocha;
            }

            const launcherCount = maxHocha > DefaultBoxCount ? maxHocha : DefaultBoxCount;
            const launchers = [];
            // set baseData and hocha first
            for(let i=1; i<=launcherCount; i++) {
                launchers.push({item:null, hocha:i});
            }
            // set item.
            data.transPlanTsrList.forEach(item => {
                const idx = item.hocha - 1;
                launchers[idx] = ({item:item, hocha:item.hocha});
            })
            setLaunchBoxList(launchers);
            setDocknoMemo(lastDockno);
        }
    };

    const onCompleteAdd = (data, clientOption) => {
        if(data.transPlanAdd.ok) {
            if(data.transPlanAdd.detail !== ApiMsg.OK) {
                addAlert({
                    title: "운송요청 추가",
                    message: [data.transPlanAdd.detail]
                });
            }
            else enqueueSnackbar('운송요청 정보가 생성되었습니다.', {variant: 'success', autoHideDuration: 1500});
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate:planDateRef.current,
                storeId:transPlanLaunchListParam.storeId,
                now:new Date().getTime()});
        }
        else addAlert({title:TransPlanLaunchDictionary.errorTitle.Add, message:[data.transPlanAdd.message]});
    };

    const onCompleteEdit = (data, clientOption) => {
        if(data.transPlanEdit.ok) {
            if(data.transPlanEdit.detail !== ApiMsg.OK) {
                addAlert({
                    title: "운송요청 수정",
                    message: [data.transPlanEdit.detail]
                });
            }
            else enqueueSnackbar('운송요청 정보가 수정되었습니다.', {variant: 'success', autoHideDuration: 1500});
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate: transPlanLaunchListParam.planDate,
                storeId: transPlanLaunchListParam.storeId,
                now: new Date().getTime()
            });
        }
        else addAlert({title:TransPlanLaunchDictionary.errorTitle.Edit, message:[data.transPlanEdit.message]});
    };

    const onCompleteRemove = (data, clientOption) => {
        if(data.transPlanRemove.ok) {
            if(data.transPlanRemove.detail !== ApiMsg.OK) {
                addAlert({
                    title: "운송요청 삭제",
                    message: [data.transPlanRemove.detail]
                });
            }
            else enqueueSnackbar('운송요청 정보가 삭제되었습니다.', {variant: 'success', autoHideDuration: 1500});
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate:planDateRef.current,
                storeId:transPlanLaunchListParam.storeId,
                now:new Date().getTime()});
        }
        else addAlert({title:TransPlanLaunchDictionary.errorTitle.Remove, message:[data.transPlanRemove.message]});
    };
    
    const onCompleteGetStoreList = (data, clientOption) => {
        if(data.arriveInfoList) {
            if(data.arriveInfoList.length > 0) {
                // sort by storeId (text)
                data.arriveInfoList.sort((a,b) => {
                    if(a.storeId < b.storeId) return -1;
                    if(a.storeId > b.storeId) return 1;
                    return 0;
                });
                if(!transPlanLaunchListParam.storeId) {
                    const store = data.arriveInfoList[0];
                    const newParam = {...transPlanLaunchListParam, storeId:store.storeId};
                    transPlanLaunchListParamRepo(newParam);
                }
            }
            arriveInfoListRepo({
                when:new Date().getTime()/1000,
                records:data.arriveInfoList
            });
        }
    };
    
    const onCompleteGetComList = (data, option) => {
        if(data.comInfoList) {
            comInfoListRepo({when:new Date().getTime()/1000, records:data.comInfoList});
        }
    };

    const onCompleteGetVehTypeList = (data, clientOption) => {
        if(data.vehTypeGroupOrderListByDc) {
            vehTypeGroupOrderListByDcRepo({when:new Date().getTime()/1000, records:data.vehTypeGroupOrderListByDc});
        }
    };

    const onCompleteGetVehInfoList = (data, clientOption) => {
        if(data.vehInfoListOfDc) {
            vehInfoListOfDcRepo({
                when:new Date().getTime()/1000,
                records:devideVehiclesByCompany(data.vehInfoListOfDc, vehSorter)
            });
        }
    };

    const onCompleteSetTruck = (data, clientOption) => {
        if(data.transPlanSetTruck.ok) {
            enqueueSnackbar('차량이 운송요청에 배차되었습니다.', {variant: 'success', autoHideDuration: 1500});
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate: transPlanLaunchListParam.planDate,
                storeId: transPlanLaunchListParam.storeId,
                now: new Date().getTime()
            });
        }
        else addAlert({title:"차량배정 오류", message:[data.transPlanSetTruck.message]});
    };

    const onCompleteOffTruck = (data, clientOption) => {
        if(data.transPlanOffTruck.ok) {
            enqueueSnackbar('[배차취소] 차량배정이 초기화되었습니다.', {variant: 'success', autoHideDuration: 1500});
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate: transPlanLaunchListParam.planDate,
                storeId: transPlanLaunchListParam.storeId,
                now: new Date().getTime()
            });
        }
        else addAlert({title:"차량배정 초기화 오류", message:[data.transPlanOffTruck.message]});
    };

    /* ################################################## */
    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 3) {
            enqueueSnackbar(AppWord.ReloadNotIn3Sec, {variant:'info', autoHideDuration:1500});
        }
        else getTransPlanTsrListUsingParam(); // Keep this call.
    };

    const onStoreSelected = (id, value) => {
        slotCountWantedRef.current = DefaultBoxCount;
        const newParam = {...transPlanLaunchListParam, storeId:value};
        transPlanLaunchListParamRepo(newParam);
    };

    const onChangePlanDate = (id, value) => {
        slotCountWantedRef.current = DefaultBoxCount;
        const newParam = {...transPlanLaunchListParam, planDate:value};
        transPlanLaunchListParamRepo(newParam);
    };

    const onRequestRemovePlan = (item) => {
        // confirm 후 요청된 것임.
        planDateRef.current = item.planDate;
        removeTransPlan({variables:{transPlan:{planId:item.planId}}});
    };

    const onRequestSave = (item, isEdit) => {
        const mutateParam = {variables:{transPlan:item}};
        planDateRef.current = item.planDate;
        if(isEdit) editTransPlan(mutateParam);
        else addTransPlan(mutateParam);
    };

    const onRequestSetTruck = (param) => {
        setTransPlanTruck({variables:{transPlan:param}});
    };

    const onRequestOffTruck = (planId) => {
        offTransPlanTruck({variables:{planId:planId}});
    };

    const onRequestPopupBindManager = (item) => {
        setBindManagerState({open:true, plan:item});
    };

    const onCloseBindManager = (changed) => {
        setBindManagerState({open:false, plan:null});
        if(changed) {
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate: transPlanLaunchListParam.planDate,
                storeId: transPlanLaunchListParam.storeId,
                now: new Date().getTime()
            });
        }
    };

    const onClickIncreaseSlot = () => {
        slotCountWantedRef.current += 1;
        // 일단 받아온 후에 원하는 수와 비교해서 처리.
        getTransPlanTsrListUsingParam(); // Keep this call.
    };

    const onClickDecreaseSlot = () => {
        if(slotCountWantedRef.current > DefaultBoxCount) {
            slotCountWantedRef.current -= 1;
            // 일단 받아온 다음에 원하는 수로 재조정할 수 있는지 판단한 후 처리.
            // 만약 받아 왔는데 받은 숫자가 원하는 수보다 크다면 줄일 수 없음.
            getTransPlanTsrListUsingParam(); // Keep this call.
        }
    };

    const onCloseUploader = (uploaded) => {
        setOpenUploader(false);
        if(uploaded) {
            // getTransPlanTsrListUsingParam();
            transPlanChangedRepo({
                planDate: transPlanLaunchListParam.planDate,
                storeId: transPlanLaunchListParam.storeId,
                now: new Date().getTime()
            });
        }
    };

    const onClickUploadPlans = () => {
        setOpenUploader(true);
    };

    const onClickNewBindDeprecated = () => {
        addAlert({
            title: '동적신규등록',
            message: [
                '동적신규등록 화면은 각 운송요청 별 동적 화면과 통합되었습니다.',
                '운송요청 중간에 있는 동적 버튼을 눌러서 신규 동적을 등록할 수 있습니다.'
            ]
        })
    };

    const loadingAny
        = responseList.loading // || responseItem.loading
        || responseStoreList.loading
        || responseVehTypeList.loading
        || responseComList.loading
        || responseVehInfoList.loading
        || responseAdd.loading
        || responseEdit.loading
        || responseRemove.loading
        || responseSetTruck.loading
        || responseOffTruck.loading;

    const holdMutation
        = responseList.loading
        || responseAdd.loading
        || responseEdit.loading
        || responseRemove.loading
        || responseSetTruck.loading
        || responseOffTruck.loading;

    const rootStyle = show
        ? undefined
        : {display:'none', visibility:'hidden', pointerEvents:'none'};

    return(
        <ContentConainer style={rootStyle}>
            {viewServiceTags}
            <ContentHeader>
                <ControlBox>
                    <VzmDateField
                        dict={{
                            id: 'planDate',
                            label: '출고일자'
                        }}
                        value={transPlanLaunchListParam.planDate || ''}
                        error={!IsValid.date(transPlanLaunchListParam.planDate)}
                        onChange={onChangePlanDate}
                    />
                    <AutoTextField
                        dict={{
                            id:'storeId',
                            label:'도착지',
                            labelKey:'storeName',
                            getOptionLabel: (opt) => opt.storeName + ' [' + opt.storeId + ']'
                        }}
                        value={transPlanLaunchListParam.storeId || ''}
                        list={storeList.records}
                        disabled={responseStoreList.loading}
                        style={{minWidth:300, marginLeft: 10}}
                        onChange={onStoreSelected}
                    />
                </ControlBox>
                <ToolBox>
                    {
                        loadingAny ?
                        <CircularProgress size={20} />
                        :
                        <IconButton
                            color={AppStyle.mui.inherit}
                            onClick={onClickReload}
                        >
                            <CachedIcon />
                        </IconButton>
                    }
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        startIcon={<AddCircleIcon />}
                        onClick={onClickIncreaseSlot}
                        style={{marginLeft:5}}
                    >
                        배차+
                    </Button>
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        startIcon={<RemoveCircleIcon />}
                        style={{marginLeft:5}}
                        disabled={launchBoxList.length <= DefaultBoxCount}
                        onClick={onClickDecreaseSlot}
                    >
                        배차-
                    </Button>
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.warning}
                        style={{marginLeft:5}}
                        startIcon={<BackupIcon />}
                        onClick={onClickUploadPlans}
                    >
                        운송요청 업로드
                    </Button>
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.info}
                        style={{marginLeft:5}}
                        startIcon={<LightbulbCircleIcon />}
                        onClick={onClickNewBindDeprecated}
                    >
                        동적신규등록(!)
                    </Button>
                </ToolBox>
            </ContentHeader>
            <ContentBody style={{
                    paddingLeft:5, whiteSpace: 'nowrap', overflowX: 'auto',
                }}
            >
                {transPlanLaunchListParam.storeId && <TransPlanLaunchItem />}
                {
                    launchBoxList.map(launcherData=>{
                        return(
                            <TransPlanLaunchItem key={launcherData.hocha}
                                hocha={launcherData.hocha}
                                baseData={baseData}
                                item={launcherData.item}
                                vehTypeList={vehTypeList}
                                comInfoList={comInfoList}
                                lastDockno={docknoMemo}
                                onRequestRemove={onRequestRemovePlan}
                                onRequestSave={onRequestSave}
                                onRequestSetTruck={onRequestSetTruck}
                                onRequestOffTruck={onRequestOffTruck}
                                onRequestPopupBindManager={onRequestPopupBindManager}
                                holdMutation={holdMutation}
                            />
                        )
                    })
                }
                {
                    launchBoxList.length === 0 && !Boolean(transPlanLaunchListParam.storeId) &&
                    <Box style={{
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'center',
                        alignItems:'center',
                        paddingTop:50
                    }}>
                        <img src={StoreHouseSvg} alt="_" height="320" />
                        <div style={{marginTop:20, fontSize:'2rem', color:'#fa3'}}>
                            점포를 선택해 주세요.
                        </div>
                    </Box>
                }
            </ContentBody>
            <TransPlanBindManager
                open={bindManagerState.open}
                onClose={onCloseBindManager}
                defaultPlan={bindManagerState.plan}
            />
            <TransPlanUploader
                open={openUploader}
                onClose={onCloseUploader}
            />
        </ContentConainer>
    );
}